import React from "react";

import Card from "../UI/Card";

import SmallHeading from "../UI/SmallHeading";

import "./style.css";

import { github } from "../../assets/icons";

const Expertise = (props) => {
  return (
    <Card
      className="expertCard"
      style={{
        padding: "30px",
        width: "320px",
        margin: "30px auto 30px",
        position: "relative",
        zIndex: 1,
      }}
      data-aos="zoom-in-up"
    >
      <a href="https://github.com/rashidRizvi98">
        {/*  <div className="flexRow align-center">
            <div style={{ width: "80px", height: "80px" }}>
              <CircularProgressbar
              value={percentage}
              text={`${percentage}%`}
              styles={buildStyles({
                textColor: colors.primaryColor,
                pathColor: colors.primaryColor,
              })}
            />
            </div>
          </div> */}
        <div className="scaleIn">
          <SmallHeading text="Click Here to see my" />
          <div style={{ display: "flex" }}>
            <img
              src={github}
              width="30px"
              height="30px"
              alt=""
              style={{ margin: "auto" }}
              loading="lazy"
            />
          </div>
          <SmallHeading text="profile!" />
        </div>
        {/* <p className="grey mtb-10 font-12 text-center">
            to visit my
            profile!
          </p> */}
      </a>
    </Card>
  );
};

export default Expertise;
